var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticClass:"project-pagination",attrs:{"current-page":_vm.currentPage,"layout":" prev, pager, next","pager-count":5,"page-size":_vm.size,"total":_vm.total,"prev-text":"上一页","next-text":"下一页","background":""},on:{"size-change":_vm.changeSizeHandle,"current-change":_vm.currentChangeHandle}})
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/my-pagination/index.vue?vue&type=template&id=5bfc3c68
// module id = null
// module chunks = 